// Boutique Vintage — Social Post design #7.
//
// Ported from the Claude Design "Fashion - Social Post" bundle
// (fashion-posts.jsx PostVintage). Renders at fixed 1080×1080.
//
// Visual: warm cream canvas, wax-seal monogram (first letter of brand_name)
// next to Playfair italic wordmark, fleuron divider above subhead, corner-
// bracketed product card with a centered product label below.
//
// Source slot mapping: brand_est → brand_tagline, "The Heritage Piece" /
// "Édition limitée · Nº 01" → caption_left / caption_right.

import type { SocialPostSlots } from '@/lib/api';
import './PostVintage.css';

interface PostVintageProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostVintage({ slots, productImageUrl }: PostVintageProps) {
  // Monogram seal — first character of the brand name, uppercased. Falls
  // back to a fleuron-style glyph if brand_name is empty.
  const seal = (slots.brand_name || '').trim().charAt(0).toUpperCase() || '✦';

  return (
    <div className="post-vintage">
      <div className="frame-pad">
        <div className="top">
          <div className="crest">
            <div className="seal">{seal}</div>
            <div>
              <div className="name">{slots.brand_name || ''}</div>
              <div className="est">{slots.brand_tagline || ''}</div>
            </div>
          </div>
          <div className="eyebrow">— {slots.eyebrow} —</div>
        </div>
        <div className="core">
          <div className="left">
            <div>
              <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
              <div className="deco"><span className="glyph">❦</span></div>
              <div className="sub">{slots.subhead}</div>
            </div>
            <ul className="bullets">
              <li><span className="glyph">i.</span><span>{slots.bullet1}</span></li>
              <li><span className="glyph">ii.</span><span>{slots.bullet2}</span></li>
              <li><span className="glyph">iii.</span><span>{slots.bullet3}</span></li>
            </ul>
          </div>
          <div className="right">
            <span className="corner tl" /><span className="corner tr" />
            <span className="corner bl" /><span className="corner br" />
            <div className="product">
              {productImageUrl ? (
                <img src={productImageUrl} alt="Product" />
              ) : (
                <div className="empty-state">Product image</div>
              )}
            </div>
            <div className="product-label">
              <div className="nm">{slots.caption_left || ''}</div>
              <div className="sub">{slots.caption_right || ''}</div>
            </div>
          </div>
        </div>
        <div className="bot">
          <div className="badge">
            <span className="stars">{slots.badge_stars}</span>
            <span>{slots.badge_text}</span>
          </div>
          <div className="handle">Find us at <span>{slots.handle}</span></div>
          <div className="cta">{slots.cta}</div>
        </div>
      </div>
    </div>
  );
}
